import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Used by shadcn/ui components
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  let d: Date;
  if (value instanceof Date) {
    d = value;
  } else {
    const raw = String(value).trim();
    const noTz = raw.match(
      /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(?:\.(\d{1,6}))?$/
    );
    const withTz = raw.match(
      /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(?:\.(\d{1,6}))?([+-]\d{2})(?::?(\d{2}))?$/
    );
    let normalized = raw;
    if (withTz) {
      const [, date, time, frac, tzHour, tzMin] = withTz;
      const ms = frac ? `.${frac.padEnd(3, '0').slice(0, 3)}` : '';
      normalized = `${date}T${time}${ms}${tzHour}:${tzMin ?? '00'}`;
    } else if (noTz) {
      const [, date, time, frac] = noTz;
      const ms = frac ? `.${frac.padEnd(3, '0').slice(0, 3)}` : '';
      normalized = `${date}T${time}${ms}Z`;
    }
    d = new Date(normalized);
  }
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString();
}
